<template>
  <div class="card-content">
   
    <div class="card-content-table">
      <el-table
        border
        :data="tableList"
        align="center"
        style="width: 100%"
        ref="table"
        :header-cell-style="headerCellStyle"
        :row-key="getRowKeys"
        :row-class-name="tableRowClassName"
        :expand-row-keys="expands"
      >
        <el-table-column label="序号" type="index" align="center" width="50">
          <template scope="scope">
            <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" align="center" prop="empName">
          <template scope="scope">
            <p>{{scope.row.empName || "--"}}</p>
          </template>
        </el-table-column>
        <el-table-column label="身份证件号" align="center" width="190" prop="idcardNumber">
          <template scope="scope">
            <p>{{scope.row.empIdcardNumber || "--"}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="证书类别"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
          prop="certType"
        >
          <template scope="scope">
            <p>{{scope.row.certTypeName || "--"}}</p>
          </template>
        </el-table-column>
        <el-table-column label="证书编号" align="center" :show-overflow-tooltip="true" prop="certNo">
          <template scope="scope">
            <p>{{scope.row.certNo || "--"}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="证书等级/执业资格类型"
          align="center"
          :show-overflow-tooltip="true"
          prop="certLevelName"
        >
          <template scope="scope">
            <p>{{scope.row.certLevelName || "--"}}</p>
          </template>
        </el-table-column>
        <el-table-column label="证书有效期至" align="center" width="105" prop="endTime">
          <template scope="scope">
            <p>{{scope.row.endTime | dateStrIntercept}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="数据来源"
          align="center"
          :show-overflow-tooltip="true"
          width="100"
          prop="dataSource"
        ></el-table-column>
        <el-table-column label="数据状态" align="center" width="120" prop="state">
          <template scope="scope">
            <p type="text" class="change-examine">
              <i :class="formatDataState(scope.row.dataState,'class')"></i>
              <span>{{scope.row.dataStateName}}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="登记日期"
          width="90"
          align="center"
          :show-overflow-tooltip="true"
          prop="createTime"
        >
          <template scope="scope">
            <p>{{scope.row.createTime?formatDate(scope.row.createTime,"yyyy-MM-dd"):'--'}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="作废日期"
          align="center"
          width="90"
          :show-overflow-tooltip="true"
          prop="cancelTime"
        >
          <template scope="scope">
            <p>{{scope.row.cancelTime?formatDate(scope.row.cancelTime,"yyyy-MM-dd"):'--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" :width="editFlag?140:100" header-align="center" align="left">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="toogleExpandTrue(scope.row)"
            >{{(editFlag && (scope.row.dataState == 4 || scope.row.dataState == 5))?'编辑':'查看'}}</el-button>
            <el-button
              type="text"
              v-if="scope.row.dataState == 4"
              @click="deleteData(scope.row.id)"
            >删除</el-button>
            <!-- 作废按钮显示判断： 非管理员 && 数据状态:1有效 2核验中 5核验不通过 && (查看页非变更状态 || 非查看页)  ps:entStatus=5=有变更待提交, entStatus=6=有变更核验中,entStatus=7=有变更核验不通过 -->
            <el-button
              type="text"
              v-if="!isAdmin && ([1,2,5].indexOf(scope.row.dataState) > -1) && (pageStatus == 'view' && [5,6,7].indexOf(entStatusCopy) == -1 || pageStatus != 'view')"
              @click="voidData(scope.row)"
            >作废</el-button>
            <!-- 变更页面 有效数据展示'变更'按钮,已作废数据展示'复制'按钮  -->
            <el-button
              type="text"
              v-if="([5,7].indexOf(entStatusCopy) > -1 && editFlag && (scope.row.dataState == 1 || scope.row.dataState == 3))"
              @click="copyOrChange(scope.row)"
            >{{scope.row.dataState == 1?'变更':'复制'}}</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column type="expand" width="1">
                    <template slot-scope="props">
                        <qualificationForm
                                :rowId="props.row.id"
                                :rowData="props.row"
                                :editFlag.sync="editFlag"
                                @saveSuccess="formSaveSuccess"
                                @formCancel="formCancel"/>
                        <span @click="toogleExpandFalse(props.row)"
                              style="position: absolute; bottom: 16px; right: 17px; font-weight: 400; color: #1890FF; font-size: 14px; cursor: pointer;">
                                    收起<i class="el-icon-arrow-up" style="color: #1890FF;margin-left: 4px;"></i>
                                </span>
                    </template>
        </el-table-column>-->
      </el-table>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getUUID } from "@/utils/index";
// import qualificationForm from "./qualificationForm"
export default {
  components: {
    // qualificationForm
  },
  props: {
    entStatus: {
      type: Number,
      default: 99
    },
    pageStatus: {
      type: String,
      default: ""
    },
    personCertificateInfoList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    entStatus: {
      immediate: true,
      handler(val) {
        this.entStatusCopy = val;
      },
      deep: true
    },
    pageStatus: {
      immediate: true,
      handler(val) {
        this.pageStatusCopy = val;
      },
      deep: true
    },
    personCertificateInfoList: {
      immediate: true,
      handler(val) {
        this.tableList = val;
        this.total = this.tableList.length;
      },
      deep: true
    }
  },
  data() {
    return {
      entStatusCopy: "",
      pageStatusCopy: "",
      expands: [], // 要展开的行，数值的元素是row的key值
      keyWord: "",
      tableList: [],
      headerCellStyle: {
        "background-color": "#EFF3F6",
        "font-size": "14px",
        color: "#000000"
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  filters: {
    dateStrIntercept(str) {
      if (str && str.length > 0) {
        return str.substring(0, 10);
      } else {
        return "--";
      }
    }
  },
  computed: {
    ...mapState({
      orgId: state => state.user.orgId,
      entId: state => state.user.userinfo.userId,
      isAdmin: state => state.user.userPermStr == "admin"
    }),
    editFlag: {
      get() {
        return this.pageStatusCopy == "edit";
      }
    }
  },
  created() {
    this.$store.dispatch("attFilesDictionary/getEntEmpCertAtt"); //获取人员资格信息附件配置
  },
  mounted() {
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.oprType) {
        return row.oprType === "4"
          ? "warning-row"
          : row.oprType === "1"
          ? "success-row"
          : "";
      } else {
        return "";
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    // 表单保存成功
    formSaveSuccess(id) {
      if (id) {
        // this.queryData();
      }
    },
    // 表单保存取消
    formCancel(id) {
      if (id.toString().indexOf("-") > -1) {
        this.deleteData(id);
      } else {
        var index = this.tableList.findIndex(val => val.id == id);
        this.$refs.table.toggleRowExpansion(this.tableList[index], false);
      }
    },
    // 搜索
    serachData() {
      this.currentPage = 1;
    //   this.queryData();
    },
    copyOrChange(row) {
      let copyOrChangeDataUrl = "/change/hentEmpCert/modifyCopy";
      this.loadingFlag = true;
      this.$httpReq.get(copyOrChangeDataUrl + "?id=" + row.id).then(res => {
        if (res.data.code != "1") {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
          return;
        }
        // this.queryData(res.data.data.id || "");
        this.$message({
          message: res.data.msg,
          type: "success"
        });
      });
    },
    // 获取数据
    // queryData(toogleRowId) {
    //   let listUrl = this.$route.params.changeId
    //     ? "/change/hentEmpCert/list"
    //     : "/entEmpCert/list";
    //   this.$httpReq
    //     .post(listUrl, {
    //       page: this.currentPage,
    //       rows: this.pageSize,
    //       filter: {
    //         entId:
    //           this.$route.params.changeId || this.$route.params.id || this.orgId
    //       },
    //       searchKey: this.keyWord,
    //       orderBy: "create_time desc"
    //     })
    //     .then(res => {
    //       if (res.data) {
    //         this.tableList = res.data.rows;
    //         this.total = res.data.total;
    //         if (toogleRowId) {
    //           var index = this.tableList.findIndex(
    //             val => val.id == toogleRowId
    //           );
    //           this.toogleExpandTrue(this.tableList[index]);
    //         } else {
    //           this.expands = [];
    //         }
    //       }
    //     });
    // },
    // 新增
    addData() {
      let hasUnSaveData = false;
      this.tableList.forEach(item => {
        if (item.id.toString().indexOf("-") > -1) {
          hasUnSaveData = true;
        }
      });
      if (hasUnSaveData) {
        this.$message({
          message: "列表里有未保存的数据项，请先保存再新增！",
          type: "error"
        });
        return;
      }

      if (this.entStatus == 0 || this.entStatus == 6) {
        this.$message({
          message:
            "请先点击【发起变更】按钮，或将上次变更的内容提交通过后再【新增】！",
          type: "error"
        });
      } else {
        let data = {
          id: getUUID(),
          dataState: 4
        };
        if (this.tableList.length == this.pageSize) this.tableList.pop();
        this.tableList.unshift(data);
        this.expands.push(this.tableList[0].id);
      }
    },
    // 删除/取消
    deleteData(id) {
      if (id.toString().indexOf("-") > 0) {
        var index = this.tableList.findIndex(val => val.id == id);
        if (index > -1) this.tableList.splice(index, 1);
      } else {
        let deleteUrl = this.$route.params.changeId
          ? "/change/hentEmpCert/delete"
          : "/entEmpCert/delete";
        this.$httpReq
          .post(deleteUrl, {
            id: id
          })
          .then(res => {
            if (res.data.code == 1) {
            //   this.queryData();
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning"
              });
            }
          });
      }
    },
    // 查看
    toogleExpandTrue(row) {
      this.$refs.table.toggleRowExpansion(row, true);
    },
    // 收起
    toogleExpandFalse(row) {
      this.$refs.table.toggleRowExpansion(row, false);
    },
    // 作废
    voidData(row) {
      this.$confirm(`确定要作废该数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let voidUrl = this.$route.params.changeId
          ? "/change/hentEmpCert/cancel"
          : "/entEmpCert/cancel";
        this.$httpReq.get(voidUrl + "?id=" + row.id).then(res => {
          if (res.data.code == 1) {
            // this.queryData();
            this.$message({
              message: res.data.msg,
              type: "success"
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning"
            });
          }
        });
      });
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    //   this.queryData();
    }
  }
};
</script>

<style lang="scss" scoped>
.card-content {
  padding: 10px 0px;
  .card-content-search {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-top: 4px;
    margin-right: 12px;
    /deep/ .el-input-group__append,
    .el-input-group__prepend {
      background-color: #1890ff;
      border: 1px solid #1890ff;
      color: #fff;
    }
  }

  .card-content-table {
    margin: 16px 12px 0 12px;
    /deep/ .el-input__inner {
      width: 100%;
    }
  }
}
</style>